module.exports = __webpack_public_path__ + "static/img/big-logo.b4b3062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/big-logo.png
// module id = 314
// module chunks = 9